import React from 'react';
import { Building2 } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function RealExPage() {
  const module = getModule('realex')!;
  return (
    <ModulePageLayout module={module} Icon={Building2}>
      <Section title="A Regulated Exchange for Real Estate">
        <p className="text-gray-700 leading-relaxed">
          RealEx is a tokenized real estate exchange built for broker-dealer compliance and real settlement
          infrastructure — not a casual marketplace. It's designed for investors who want liquidity in an
          asset class that traditionally has none.
        </p>
      </Section>

      <Section title="Built for Compliance">
        <FeatureGrid
          items={[
            { title: 'Investor Profiles', body: 'Tracks accreditation status, total invested, and KYC level — accredited and non-accredited investors see different offerings.' },
            { title: 'Broker-Dealer Layer', body: 'A regulated intermediary manages licensing, reporting, and investor suitability for every offering.' },
            { title: 'Settlement Tracking', body: 'Trade settlement type, date, amount, and status are tracked through to a clearing house reference.' },
            { title: 'Compliance Logging', body: 'KYC checks, AML flags, and regulatory audits are all logged, with accounts frozen or unfrozen based on findings.' },
          ]}
        />
      </Section>

      <Section title="How Trading Works">
        <p className="text-gray-700 leading-relaxed">
          Properties list with full details, total value, available fractions, and projected annual yield.
          An order book matches market and limit orders, recording execution price, quantity, and fees on
          every fill. Seller-financed deals are also supported, where the seller
          retains a percentage and receives payments over time — with performance deadlines built in.
        </p>
      </Section>
    </ModulePageLayout>
  );
}
